module.exports = __webpack_public_path__ + "media/customizations/santaritaranch/logo-9ba986c92ac83fb7d01a677a709ad0a2.png";